import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_025",
  "use": "icon-su_025-usage",
  "viewBox": "0 0 24 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 48\" id=\"icon-su_025\"><defs><style>#icon-su_025 .cls-1,#icon-su_025 .cls-2{fill:#ccc;}#icon-su_025 .cls-1{opacity:0;}</style></defs><g id=\"icon-su_025_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_025_icon\"><rect class=\"cls-1\" width=\"24\" height=\"48\" /><path class=\"cls-2\" d=\"M0,48V0L24,24Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol